export default "__VITE_ASSET__BqIKe8dq__"